import { StorageService } from '@shared/services/storage.service';
import { ZSuiteHelper } from './zsuite-helper';

export class ThemeHelper {
  public static get theme(): string {
    const userTheme = localStorage.getItem(StorageService.userTheme);
    return ZSuiteHelper.isClinical() ? 'roboze_incloud_clinical' : userTheme || 'roboze_incloud';
  }
}